import clsx from "clsx";
import GeneralLayout from "@/layouts/General";
import CenteredHero from "@/components/CenteredHero";
import NavBorderSeparator from "@/assets/imgs/our-story/nav-border-separator.png"
import { Link, useNavigate, useParams } from "react-router-dom";
import NavBorder from "@/assets/imgs/our-story/nav-border.png"
import NavBgBorder from "@/assets/imgs/our-story/nav-bg-border.webp"
import { useGlobalContext } from "@/global/GlobalContext";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import HTMLFlipBook from "react-pageflip"
import RestaurantAPI from "@/app/api/di-sini/restaurant";
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton";
const restaurantApi = new RestaurantAPI()

const Menu = () => {
  const { notifyError } = useGlobalContext()
  const { slug } = useParams()
  const navigate = useNavigate()
  const [selectedMenu, setSelectedMenu] = useState(null)
  const [tempSelectedMenu, setTempSelectedMenu] = useState(null)
  const defaultImgSize = { w: 500, h: 660, minW: 315, maxW: 1000, minH: 400, maxH: 1533 }
  const [imgSize, setImgSize] = useState(defaultImgSize)
  const book = useRef(null)
  const menuContainerRef = useRef(null)
  const selectedMenuName = useRef("")
  const [activePage, setActivePage] = useState(0)
  const [menus, setMenus] = useState([])
  const [onReq, setOnReq] = useState(true)
  const mediaLg = window.matchMedia("(min-width: 1024px)")
  const [allLoaded, setAllLoaded] = useState(false)
  const [loadedImgs, setLoadedImgs] = useState(0)
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [currWindowWidth, setCurrWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    getMenus()
  }, [])

  useLayoutEffect(() => {
    handleOverflow()
  }, [allLoaded])

  useLayoutEffect(() => {
    const handleResize = () => {
      handleOverflow()
      setCurrWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)
  }, [currWindowWidth])

  useLayoutEffect(() => {
    const timer = setTimeout(() => setAllLoaded(loadedImgs == menus.length), 1000)

    return () => clearTimeout(timer)
  }, [loadedImgs])

  useLayoutEffect(() => {
    if (menus.length > 0) {
      handleSelectedMenu()
    }
  }, [menus])

  useLayoutEffect(() => {
    if (tempSelectedMenu) {
      if (tempSelectedMenu.name.toLowerCase() == "beverages") {
        setImgSize({ w: 350, h: 950, minW: 115, maxW: 700, minH: 690, maxH: 1823 })
      } else {
        setImgSize(defaultImgSize)
      }
    }
  }, [tempSelectedMenu])

  useLayoutEffect(() => {
    setSelectedMenu(tempSelectedMenu)
  }, [imgSize])

  const handleOverflow = () => {
    const el = menuContainerRef.current

    if (el) setIsOverflowing(el.scrollWidth > el.clientWidth)
  }

  const handleSelectedMenu = (param = "") => {
    setSelectedMenu(null)
    const selected = menus.find((val, i) => {
      if (slug || param) {
        return val.name.toLowerCase() == (param.toLocaleLowerCase() || slug.replaceAll("-", " "))
      } else {
        return i == 0
      }
    })

    if (!selected) return navigate("/page-not-found", { replace: true })
    selectedMenuName.current = selected.name
    setTempSelectedMenu(selected)
  }

  const onClickTabMenu = (name) => {
    setActivePage(0)
    handleSelectedMenu(name)
  }

  const handleImageLoad = () => {
    setLoadedImgs((prev) => typeof prev === "number" ? prev + 1 : 1)
  }

  const createLink = (name) => {
    const converted = name.toLowerCase().replaceAll(" ", "-")
    return `/di-sini/menus/${converted}`
  }

  // API request
  const getMenus = async () => {
    // setOnReq(true)
    setAllLoaded(false)
    try {
      const { data } = await restaurantApi.getMenus()
      setMenus(data.data.menus)
    } catch (err) {
      notifyError(err.message)
    }
    // setOnReq(false)
  }

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <CenteredHero title="Menu" custCls="bg-[url('/src/assets/imgs/di-sini/menu/banner.jpg')] h-[60vh]" custTitleFont="font-sloopScriptPro mb-0" custParagraphFont="font-agcasmlt tracking-wider font-extralight" />
        {/* max-lg:px-1 lg:w-[950px] lg:min-w-[950px] lg:max-w-[1150px] mx-auto */}
        <div ref={menuContainerRef} className="w-[90%] max-lg:px-1 mx-auto flex justify-center overflow-x-auto overflow-y-hidden h-full mb-0.5">
          <ul className={clsx("w-full flex md:w-[80%] mb-5 sm:mb-10 mt-2.5 sm:mt-5", { "gap-1": !allLoaded, "justify-center": !isOverflowing, "justify-start": isOverflowing })}>
            {!allLoaded ?
              Array.from({ length: 2 }, (_, i) => (
                <li key={i}>
                  <ContainerSkeleton custH="h-5 sm:h-8" custW="w-24 sm:w-32 lg:w-[152px] 2xl:w-36 flex justify-center items-center" />
                </li>
              ))
              :
              menus.map((d, i) => (
                <li key={i}>
                  <div className={clsx("w-24 sm:w-32 lg:w-[152px] 2xl:w-36 flex justify-center items-center px-1 pt-[1px] lg:pt-0.5 relative", { "hidden": !allLoaded })}>
                    <img width="100" src={NavBorder} onLoad={handleImageLoad} className="w-full" />
                    {selectedMenuName.current == d.name && (
                      <img width="100" src={NavBgBorder} className="w-full absolute" />
                    )}
                    <Link to={createLink(d.name)} className="absolute max-lg:top-1 text-[10px] sm:text-xl font-agcasmlt font-extralight tracking-wide text-charcoal-black capitalize" onClick={() => onClickTabMenu(d.name)}>{d.name}</Link>
                    {allLoaded &&
                      i < menus.length - 1 && (
                        <img width="40" src={NavBorderSeparator} className="absolute sm:-top-[1px] lg:top-[1px] -right-3 sm:-right-5 w-[24px] sm:w-[38px] lg:w-[42px]" />
                      )}
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
        <section className="pb-10 overflow-hidden">
          <div className="bg-[url('/src/assets/imgs/di-sini/menu/background.jpg')] py-10 bg-cover bg-no-repeat bg-center">
            <div className="w-[90%] md:w-[80%] mx-auto">
              {allLoaded ?
                selectedMenu ? (
                  selectedMenu?.photos.length > 0 && (
                    <div className="">
                      <HTMLFlipBook ref={book} size="stretch" width={imgSize.w} height={imgSize.h} minWidth={imgSize.minW} maxWidth={imgSize.maxW} minHeight={imgSize.minH} maxHeight={imgSize.maxH} maxShadowOpacity={0.5} mobileScrollSupport={true}
                        onFlip={() => {
                          const currPageId = book.current.pageFlip().getCurrentPageIndex()
                          if (selectedMenu?.photos.length % 2 != 0) {
                            if (currPageId == selectedMenu?.photos.length - 1 && (mediaLg.matches || (!mediaLg.matches && tempSelectedMenu.name.toLowerCase() == "beverage"))) return setActivePage(currPageId - 1)
                            setActivePage(currPageId)
                          } else {
                            if (currPageId == selectedMenu?.photos.length - 1 && (mediaLg.matches || (!mediaLg.matches && tempSelectedMenu.name.toLowerCase() == "beverage"))) return
                            setActivePage(currPageId)
                          }
                        }}
                      >
                        {selectedMenu?.photos.map((p, idx) => (
                          <img key={idx} height="100" src={p} className="demoPage" />
                        ))}
                      </HTMLFlipBook>
                      <div className="flex justify-center mt-5">
                        <div className="flex items-center">
                          <button type="button" onClick={() => {
                            const currPageId = book.current.pageFlip().getCurrentPageIndex()
                            if (currPageId == 0) return
                            setActivePage(!mediaLg.matches && tempSelectedMenu.name.toLowerCase() == "beverage" ? currPageId - 2 : currPageId - 1)
                            book.current.pageFlip().flipPrev()
                          }}><FontAwesomeIcon icon={faChevronLeft} size="xl" className="text-white" />
                          </button>
                          <div className="flex gap-1 mx-8">
                            {/* onClick={() => {
                              setActivePage(i)
                              book.current.pageFlip().flip(i)
                            }} */}
                            {Array.from({ length: mediaLg.matches || (!mediaLg.matches && tempSelectedMenu.name.toLowerCase() == "beverage") ? selectedMenu?.photos.length - 1 : selectedMenu?.photos.length }).map((_, i) => (
                              <button key={i} type="button" className={clsx("rounded w-2 h-2 bg-white cursor-auto", { "opacity-50": activePage != i, })}>
                              </button>
                            ))}
                          </div>
                          <button type="button" onClick={() => {
                            const currPageId = book.current.pageFlip().getCurrentPageIndex()
                            if (selectedMenu?.photos.length % 2 != 0) {
                              if (currPageId == selectedMenu?.photos.length - 1) return
                              setActivePage(currPageId + 1)
                            } else {
                              if ((currPageId == selectedMenu?.photos.length - 2 && mediaLg.matches) || (currPageId == selectedMenu?.photos.length - 1 && !mediaLg.matches)) return
                              setActivePage(currPageId + 1)
                            }
                            book.current.pageFlip().flipNext()
                          }}><FontAwesomeIcon icon={faChevronRight} size="xl" className="text-white" />
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <p className="text-center text-gray-500">No menu available.</p>
                )
                :
                <Loading imgSize={imgSize} />
              }
            </div>
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

const Loading = ({ imgSize }) => {
  return (
    <>
      <div className="animate-pulse h-full w-full" style={{ height: `${imgSize.h}px` }}>
        <div className="h-full w-full bg-[#e4cbb1] opacity-35"></div>
      </div>
    </>
  )
}

export default Menu;